const base_app_url="https://kharbouch-soufiane.com/zenhair/index.php";
const global_gift_value=1000;
var dist_id='';
var dist_id_api='';
var dist_email='';
var dist_code='';
var dist_name='';
function getUrlGet(name){
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results==null){
       return null;
    }
    else{
       return results[1] || 0;
    }
}

if(getUrlGet('id')){
    FetchData(base_app_url, { dist_exist_klav: true, id: getUrlGet('id')}).then((data) => {
        if(data['data'].length>0){
            $('.container').show()
            $('.errorPage').hide()
            dist_id=data['data'][0]['attributes']['email'];
            dist_id_api=data['data'][0]['attributes']['email'];
            dist_email=data['data'][0]['attributes']['email'];
            dist_name=data['data'][0]['attributes']['first_name'] || '';
            var curr=$('.HelloContainer').html()+"".toString()
            $('.HelloContainer').html(curr.replace('Customer',data['data'][0]['attributes']['first_name']||''));
            var str=data['data'][0]['attributes']['first_name'] || '';
            var arr='abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
            var only_latin=true;
            for(var c of str){
                if(arr.includes(c)===false) only_latin=false;
            }
            if(!only_latin){
                dist_code='';  
                str='';
            }
            
            if(str.length>0){
                str=str.replaceAll(' ','');
                GetDiscount(str).then((data) => {
                    dist_code=JSON.stringify(data['code']).replaceAll('"','');
                });
  
            }
           
            console.log(JSON.stringify(data['customer']))
        }else{
            $('.container').hide();
            $('.errorPage').show()
        }
    })
}
async function FetchData(url = "", data = {}) {
    const response = await fetch(url, {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
      redirect: "follow",
      referrerPolicy: "no-referrer",
      body: JSON.stringify(data),
    });
    return response.json();
}

async function GetDiscount(code){
    return FetchData(base_app_url, { code_exist: true,code:code}).then((data) => {
        return data;
    });
}


$('.AddForm').submit(function(event){
    event.preventDefault()
    var email_value = "" + $('.Email_Input').val();
    var field = $('.Email_Input');
    var elready_exist = false;

    $('.FriendDivContainer').each(function() {
        if (email_value == $(this).attr('data-email')) {
            elready_exist = true;
        }
    });

    var its_my_email = false;
    if (email_value == dist_email) {
        its_my_email = true;
    }

    if (its_my_email) {
        field.removeClass('validateField');
        field.addClass('errorField');
        show_error(t_msg7, $(".MsgErrors"));
        ValidateForm();
    } else if (elready_exist) {
        field.removeClass('validateField');
        field.addClass('errorField');
        show_error(t_msg2, $(".MsgErrors"));
        ValidateForm();
    } else {
        FetchData(base_app_url, {
            email_exist: true,
            email: email_value
        }).then((data) => {
            if (Object.keys(data).length > 0) {
                field.addClass('validateField');
                field.removeClass('errorField');
                var newFriend = friendItem + "".toString();
                newFriend = newFriend.replaceAll('[[customer_name]]', data['firstName']);
                newFriend = newFriend.replaceAll('[[customer_email]]', data['email']);
                newFriend = newFriend.replaceAll('[[customer_id]]', data['id']);
                newFriend = newFriend.replaceAll('[[customer_code]]', dist_code);
                $(newFriend).insertAfter($('.EmptyDiv').eq(0));
                $('.EmptyDiv').eq(0).remove();
                attributeCodes();
                $('.RemoveBtn').find('span').off();
                $('.RemoveBtn').find('span').click(function() {
                    var NewemptyFriend = emptyFriend + "".toString();
                    if ($('.EmptyDiv').length == 0) {
                        NewemptyFriend = NewemptyFriend.replaceAll('[[i]]', 10);
                        $(NewemptyFriend).insertAfter($('.FriendDivContainer:last'));
                    } else {
                        NewemptyFriend = NewemptyFriend.replaceAll('[[i]]', Number($('.EmptyDiv').eq(0).attr('data-i') - 1));
                        $(NewemptyFriend).insertBefore($('.EmptyDiv').eq(0));
                    }
                    $(newFriend).remove();
                    $(this).closest('.FriendDivContainer').remove();
                    attributeCodes();
                    ValidateForm();
                });
                ValidateForm();
            } else {
                field.addClass('validateField');
                field.removeClass('errorField');
                var newFriend = friendItem + "".toString();
                newFriend = newFriend.replaceAll('[[customer_name]]', '');
                newFriend = newFriend.replaceAll('[[customer_email]]', email_value);
                newFriend = newFriend.replaceAll('[[customer_id]]', '');
                newFriend = newFriend.replaceAll('[[customer_code]]', dist_code);
                $(newFriend).insertAfter($('.EmptyDiv').eq(0));
                $('.EmptyDiv').eq(0).remove();
                attributeCodes();
                $('.RemoveBtn').find('span').off();
                $('.RemoveBtn').find('span').click(function() {
                    var NewemptyFriend = emptyFriend + "".toString();
                    if ($('.EmptyDiv').length == 0) {
                        NewemptyFriend = NewemptyFriend.replaceAll('[[i]]', 10);
                        $(NewemptyFriend).insertAfter($('.FriendDivContainer:last'));
                    } else {
                        NewemptyFriend = NewemptyFriend.replaceAll('[[i]]', Number($('.EmptyDiv').eq(0).attr('data-i') - 1));
                        $(NewemptyFriend).insertBefore($('.EmptyDiv').eq(0));
                    }
                    $(newFriend).remove();
                    $(this).closest('.FriendDivContainer').remove();
                    attributeCodes();
                    ValidateForm();
                });
                ValidateForm();
            }
            field.val("");
        });
    }   
});


function processAddForm() {
    if(dist_code==""){
        $('.NameForm').css({display:"flex"});
        return
    }
    $('.loadingContainer').css({display:"flex"});
    $('.NameForm').hide();
  var codes=[];
  var i;
  $('.FilledFriend').each(function(){
        var code={
            created_by:dist_name,
            code:dist_code+""+Number($(this).index()+1),
            customer_email:$(this).attr("data-email"),
            customer_id:$(this).attr("data-id"),
            amount:'150',
            created_by_id:dist_id_api,
            }
        codes.push(code);
        i=Number($(this).index()+1);
    })
    var code={
        created_by:dist_name,
        code:dist_code+""+Number(i+1),
        customer_email:"",
        customer_id:"",
        amount:'150',
        created_by_id:dist_id_api,
    }
    codes.push(code);
    $('.distHisCode').html(dist_code+""+Number(i+1));
  FetchData(base_app_url, { create_discounts: true,codes:codes}).then((data) => {
    $('.NameForm').hide();
    $('.loadingContainer').hide();
    $('.DoneContainer').css({display:"flex"});
    });
}

$('.SubmitBtn').click(function(event){
    processAddForm();
});

$('.FinishBtn').click(function(){
    location.reload();
})
$('.NameForm').submit(function(event){
    $('.loadingContainer').css({display:"flex"});
    event.preventDefault()
    var name=$(this).find('#name').val()+"";
    dist_name=name;
    name=name.replaceAll(' ','');
    GetDiscount(name).then((data) => {
        dist_code=JSON.stringify(data['code']).replaceAll('"','');
        processAddForm();
    });
})

$('.CancelBtn').click(function(){
    $('.NameForm').hide();
})

function show_error(text,container){
    container.html(text);
    container.show()
    setTimeout(function(){container.hide()},3000);
}

function ValidateForm(){
    if($('.EmptyDiv').length<10){
        $('.SubmitBtn').removeAttr('disabled');
        
    }else{
        $('.SubmitBtn').attr('disabled', 'disabled');
        
     
    }
    if($('.EmptyDiv').length == 0){
        $('.AddBtnContainer').attr('disabled', 'disabled')
    }else{
        $('.AddBtnContainer').removeAttr('disabled');
    }
} 

function attributeCodes(){
    $('.CustomerCode').each(function(){
        $(this).html(dist_code+""+Number($(this).closest('.FriendDivContainer').index()+1))
    })
}


